import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import { useNavigate } from "react-router-dom";

const ModalLimitOfRoutes = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          //   background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        },
      }}
    >
      <DialogTitle
        sx={{ fontWeight: "bold", color: "#e7ef7d", textAlign: "center" }}
      >
        📢 ¡Has alcanzado el límite de rutas permitidas en tu membresía actual!
      </DialogTitle>

      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <DialogContentText
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            fontStyle: "italic",
            fontWeight: "medium",
          }}
        >
          Gracias por usar nuestra plataforma y crear rutas increíbles. Para
          seguir guardando más rutas y disfrutar de beneficios exclusivos, te
          invitamos a explorar nuestras membresías.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3, gap: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="white"
          sx={{
            borderRadius: 50,

            px: 4,
            py: 1,
            fontWeight: "bold",
            textTransform: "none",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
            },
          }}
        >
          Aceptar
        </Button>
        <Button
          onClick={() => navigate("/dashboard/list-memberships")}
          variant="contained"
          sx={{
            borderRadius: 50,
            backgroundColor: "#e7ef7d",
            px: 4,
            py: 1,
            fontWeight: "bold",
            textTransform: "none",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
            },
          }}
          startIcon={<CardMembershipIcon />}
        >
          Membresías
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalLimitOfRoutes;
